// The modules this shell composes, and where. SOW-01 has one shell for all six Web MMS modules (ADR-0003); adding a
// module is one line here. Splitting into several shells later means another apps/web-<portal> with its own list.
import * as clients from '@care-platform/feature-clients';
import * as dashboard from '@care-platform/feature-dashboard';
import * as activation from '@care-platform/feature-mcm-activation';
import type { ModuleMount } from '@care-platform/shell';

export const mounts: ModuleMount[] = [
  { name: 'dashboard', basePath: 'dashboard', module: dashboard },
  { name: 'clients', basePath: 'clients', module: clients },
  { name: 'activation', basePath: 'activate-mcm', module: activation },
];

/** Where `/` goes. */
export const HOME_ROUTE = 'dashboard.home';
